export default __webpack_public_path__ + "images/fe181f7127a759a08b10df5c524cc6ed.png";